module.exports = __webpack_public_path__ + "d743aa7203da7dfb1c17fd6ee10f4c1c.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Kartbox/img/pakistan500.gif
 ** module id = 472
 ** module chunks = 0
 **/